import { Injectable } from '@angular/core';
import type { OfflineSnapshotStore } from './offline-snapshot-store.types';
import type { StoredOfflineSnapshot } from './offline-snapshot.types';
import { IndexedDbObjectStore } from './indexed-db-object-store';

@Injectable({ providedIn: 'root' })
export class OfflineSnapshotDatabase implements OfflineSnapshotStore {
  private readonly objectStore =
    new IndexedDbObjectStore<StoredOfflineSnapshot>({
      databaseName: 'OutkeepOfflineDB',
      keyPath: 'key',
      storeName: 'snapshots',
      version: 1,
    });

  delete(key: string): Promise<void> {
    return this.objectStore.delete(key);
  }

  entries(): Promise<StoredOfflineSnapshot[]> {
    return this.objectStore.entries();
  }

  get(key: string): Promise<StoredOfflineSnapshot | null> {
    return this.objectStore.get(key);
  }

  put(record: StoredOfflineSnapshot): Promise<void> {
    return this.objectStore.put(record);
  }
}
